import './polyfils.js';
import "babel-polyfill";

import ProgressBar from 'progressbar.js';
import './css/index.css';
import { StudioLauncher, StudioState } from './js/studio/StudioLauncher.js';
import { ALCHEMISTEN, checkMobile } from 'da-three';

let circleDiv = document.getElementById("progress-circle");
let errorDiv = document.getElementById("error-msg");
let playDiv = document.getElementById("play-btn");
let loadingScreenDiv = document.getElementById("loading_screen");
let title = document.getElementsByTagName("title")[0];
let orientationDiv = document.getElementById("orientation-warning");

let loginMask = document.getElementById("login-mask");
loginMask.style.display = "none";

let userName = document.getElementById("username");
let password = document.getElementById("password");

loginMask.addEventListener("submit", () => {
    event.preventDefault();
    bar.animate(0.1);
    ALCHEMISTEN.instance.auth.authUser(userName.value, password.value, (error) => {
        if (error === null) {
            errorDiv.innerHTML = "Logged in";
            bar.animate(1);
            launcher.continue();
        } else {
            bar.animate(0);
            errorDiv.innerHTML = error.message;
        }
    });
});

document.getElementById('loading_screen').style.backgroundImage = "url(" + process.env.PUBLIC_URL + "/img/bg_scene_default.jpg)";

let bar = new ProgressBar.Circle(circleDiv, {
    strokeWidth: 6,
    easing: 'easeInOut',
    duration: 550,
    color: '#00C2FF',
    trailColor: 'rgba(0, 0, 0,.3)',
    trailWidth: 6,
    svgStyle: null
});

let launcher = new StudioLauncher();
const states = StudioState;
let state;

window.addEventListener("orientationchange", function (event) {
    window.setTimeout(() => {
        let isPortrait = window.matchMedia("(orientation: portrait)").matches;
        if (checkMobile() && launcher && launcher.config && launcher.config.project.orientation !== 'all') {
            if (isPortrait) {
                orientationDiv.style.display = "block";
                playDiv.style.display = "none";
            } else {
                orientationDiv.style.display = "none";
                playDiv.style.display = "block";
                if (launcher.readyToLaunch && state !== states.EMBEDDED_MODE) {
                    launcher.launchStudio();
                }
            }
        }

     }, 500)
    
});

function setOrientationCheck() {
    if (checkMobile() && window.matchMedia("(orientation: portrait)").matches) {
        orientationDiv.style.display = "block";
        playDiv.style.display = "none";
        launcher.autoStart = false;
    }
}



// state
launcher.dispatcher.addEventListener('status', (eventType, data) => {
    state = data.state;

    switch (state) {
        case states.INITIALIZING:
            console.log("Studio is initializing");
            break;
        case states.CONFIG_LOADED:
            loginMask.style.display = "none";    
            playDiv.style.opacity = 1;
            circleDiv.className += " circle-hide";   
            if (data.config.project.orientation !== 'all') {
                setOrientationCheck();
            }
            let name = data.config.project.name;
            
            name = ALCHEMISTEN.instance.i18n.translate(name, data.config.project.projectID);

            title.innerHTML = name;
            errorDiv.innerHTML = name;
            if (data.config.surrounding.background !== '' && !data.config.features.useTransparency.active) {
                document.getElementById('fullscreen').style.backgroundImage = 'url("'+data.config.project.basedir+data.config.surrounding.background+'")';
            }
            break;    
        case states.ERROR_NO_CONTINUE:
            console.log("Error no continue", data);
            break;
        case states.LAUNCHING_STUDIO:
            loadingScreenDiv.remove();
            break;
        case states.EMBEDDED_MODE:
            playDiv.className += " btn-show";
            playDiv.onclick = function () {
                launcher.launchStudio();
            };
            break;    
        case states.LOADING_CONFIG:
            title.innerHTML = "Projekt: " + data.projectID;    
            break; 
        case states.REQUIRE_LOGIN:
            title.innerHTML = "Login";
            errorDiv.innerHTML = "Login required";
            loginMask.style.display = "block";
            // hide play button
            playDiv.style.opacity = 0;
            break;
        default:
            console.warn("Unused status type", eventType, data);    
    }
});

// progress
launcher.dispatcher.addEventListener('progress', (eventType, progress) => {
    bar.animate(progress.loaded / progress.total);
});

// error
launcher.dispatcher.addEventListener('error', (eventType, error) => {
    errorDiv.innerHTML = error.humanMessage;
    loadingScreenDiv.className = error.className || "";
    console.error(error);
});

// params
launcher.dispatcher.addEventListener('params', (eventType, params) => {
    if (params.transparent){
        document.getElementById('loading_screen').style.backgroundImage = 'none';
    }
});

// start it!
launcher.launch();



// WEBPACK FOOTER //
// ./src/studio.js